export default "__VITE_ASSET__087d3bb0__"